webpackJsonp([46],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(255);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(132);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(172);

__webpack_require__(179);

var _util = __webpack_require__(134);

var _util2 = _interopRequireDefault(_util);

var _vant = __webpack_require__(36);

var _vant2 = _interopRequireDefault(_vant);

__webpack_require__(171);

var _http = __webpack_require__(133);

var _vueAwesomeSwiper = __webpack_require__(253);

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

__webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_util2.default);

_vue2.default.use(_vant2.default);

_vue2.default.prototype.$http = _http.apiAxios;

_vue2.default.use(_vueAwesomeSwiper2.default);

new _vue2.default({
    el: '#app',
    router: _router2.default,
    components: { App: _App2.default },
    template: '<App/>'
});

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {};
  },

  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
    }
  }
};

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(257);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [{
    path: "/",
    name: "index",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(306)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/contract",
    name: "contract",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(305)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/game",
    name: "game",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/app",
    name: "app",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(263)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/wcjq",
    name: "wcjq",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(281)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/rxcs",
    name: "rxcs",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(280)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/rxcs2",
    name: "rxcs2",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(274)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/rxcs3",
    name: "rxcs3",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(275)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy",
    name: "yw_lhdzy",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_a",
    name: "yw_lhdzy_a",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_b",
    name: "yw_lhdzy_b",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_c",
    name: "yw_lhdzy_c",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(300)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_d",
    name: "yw_lhdzy_d",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(301)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_e",
    name: "yw_lhdzy_e",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(302)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_f",
    name: "yw_lhdzy_f",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_1",
    name: "yw_lhdzy_1",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_2",
    name: "yw_lhdzy_2",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(293)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_3",
    name: "yw_lhdzy_3",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(294)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_4",
    name: "yw_lhdzy_4",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(295)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_5",
    name: "yw_lhdzy_5",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(296)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/yw_lhdzy_6",
    name: "yw_lhdzy_6",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/gzyw_lhdzy_1",
    name: "gzyw_lhdzy_1",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(265)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/xn_cycq_a",
    name: "xn_cycq_a",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(282)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_zhangji_a",
    name: "jq_zhangji_a",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(273)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_rongyao_a",
    name: "jq_rongyao_a",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(269)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_rongyao_b",
    name: "jq_rongyao_b",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(271)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_rongyao_c",
    name: "jq_rongyao_c",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(272)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_guijian_a",
    name: "jq_guijian_a",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(266)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_guijian_b",
    name: "jq_guijian_b",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(267)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_guijian_c",
    name: "jq_guijian_c",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(268)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jq_guijian1004",
    name: "jq_guijian1004",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(270)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jiaoyin",
    name: "jiaoyin",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(276)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1001",
    name: "jy_baye1001",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(283)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1002",
    name: "jy_baye1002",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(284)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1003",
    name: "jy_baye1003",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(285)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1004",
    name: "jy_baye1004",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(286)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1005",
    name: "jy_baye1005",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(287)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1006",
    name: "jy_baye1006",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(288)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1007",
    name: "jy_baye1007",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(289)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1008",
    name: "jy_baye1008",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(290)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1009",
    name: "jy_baye1009",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(291)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1010",
    name: "jy_baye1010",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(113)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/jy_baye1011",
    name: "jy_baye1011",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(113)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/md_1011",
    name: "md_1011",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(277)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/md_1002",
    name: "md_1002",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(278)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/md_1003",
    name: "md_1003",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(279)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}];

var router = new _vueRouter2.default({
    mode: 'history',
    disableDotRule: true,
    routes: routes
});
exports.default = router;

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(135);

var _promise2 = _interopRequireDefault(_promise);

exports.apiAxios = apiAxios;

var _axios = __webpack_require__(114);

var _axios2 = _interopRequireDefault(_axios);

var _vant = __webpack_require__(36);

var _qs = __webpack_require__(181);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.timeout = 50000;
_axios2.default.interceptors.request.use(function (config) {
    var user = "";
    if (user) {
        config.headers = {
            Authorization: "bearer " + user.token
        };
    }
    config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8;'
    };
    return config;
}, function (error) {
    return _promise2.default.reject(error);
}, function (error) {
    return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (res) {
    var status = res.data.status,
        message = res.data.msg;
    switch (status) {
        case 1:
            return res;
            break;
        default:
            _vant.Dialog.alert({
                title: "提示",
                message: message ? message : "网络请求异常，请稍候再试"
            }).then(function (r) {
                return function () {};
            });
            break;
    }
}, function (error) {
    _vant.Dialog.alert({
        title: '提示',
        message: error.message.includes('timeout') ? '网络请求超时，请稍候再试' : '网络请求异常，请稍候再试'
    }).then(function (r) {
        return function () {};
    });
    return _promise2.default.reject(error);
});

function apiAxios(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "post";
    var loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (loading) {
        _vant.Toast.loading({
            message: "加载中...",
            duration: 1000000
        });
    }
    method = method.toUpperCase();
    var config = {
        method: method,
        url: url,
        transformRequest: [function (data) {
            return _qs2.default.stringify(params);
        }]
    };

    return new _promise2.default(function (resolve, reject) {
        (0, _axios2.default)(config).then(function (res) {
            if (loading) {
                _vant.Toast.clear();
            }
            if (res.status === 200) {
                resolve(res.data);
            }
        }).catch(function (response) {
            if (loading) {
                _vant.Toast.clear();
            }
            reject(response);
        });
    });
}

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vant = __webpack_require__(36);

exports.default = {

    install: function install(Vue, options) {
        Vue.prototype.BRToast = function () {
            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '提示';

            (0, _vant.Toast)({
                mask: false,
                message: title
            });
        };

        Vue.prototype.BRDialog = function () {
            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '提示';
            var message = arguments[1];
            var yesCallback = arguments[2];
            var cancelCallback = arguments[3];

            _vant.Dialog.confirm({
                title: title,
                message: message,
                showCancelButton: false }).then(function () {
                if (yesCallback) {
                    yesCallback();
                }
            }).catch(function () {
                if (cancelCallback) {
                    cancelCallback();
                }
            });
        };

        Vue.prototype.BRShowLoad = function () {
            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '加载中';
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;

            _vant.Toast.loading({
                mask: true,
                message: title,
                duration: duration,
                forbidClick: true });
        };

        Vue.prototype.BRHideLoad = function () {
            _vant.Toast.clear();
        };

        Vue.prototype.BRUrlBack = function () {
            this.$router.back(-1);
        };

        Vue.prototype.isSetString = function (str) {
            if (str !== null && str !== undefined && str !== '') {
                return true;
            } else {
                return false;
            }
        };
        Vue.prototype.dataEq = function (str1, str2) {
            if (str1 !== str2) {
                return false;
            } else {
                return true;
            }
        };

        Vue.prototype.runRomSystem = function () {

            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            var isIOS = u.match(/iPhone|iPad|iPod|ipad|Mac|mac/i);
            var isIE = u.match(/IEMobile/i);
            return isIOS ? 'ios' : 'android';
        };

        Vue.prototype.isRunInWeChatApp = function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        };

        Vue.prototype.getUrlParamsCode = function () {
            var URLParams = new Array();
            var aParams = document.location.search.substr(1).split('&');
            for (var i = 0; i < aParams.length; i++) {
                var aParam = aParams[i].split('=');
                URLParams[aParam[0]] = decodeURI(aParam[1]);
            }
            return URLParams;
        };
    }
};

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(173)

var Component = __webpack_require__(111)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
module.exports = __webpack_require__(107);


/***/ })

},[260]);


// WEBPACK FOOTER //
// static/js/app.7e2f289ce75002949d93.js